import React from 'react';
import {
  Flex,
  HStack,
  StackDivider,
  Image,
} from '@chakra-ui/react';

const PartnerHeader = ({ logo, name, logoHeight }: {
  logo?: string,
  name: string,
  logoHeight?: string
}): JSX.Element => (
  <Flex maxW="7xl" mx="auto" p={8}>
    <HStack align="center" spacing={10} divider={<StackDivider />}>
      {
        logo
          ? (
            <>
              <Image
                src={logo}
                alt={name}
                height={logoHeight || '36px'}
                objectFit="contain"
              />
            </>
          )
          : undefined
      }
      <Image
        src="/static/images/logo.png"
        alt=""
        height="36px"
        objectFit="contain"
      />
    </HStack>
  </Flex>
);

export default PartnerHeader;
